export function isKeyOf<T extends string>(
  key: string,
  record: Record<T, unknown>,
): key is T {
  return key in record;
}
